import { COMMON_CLEAN_FORM_DATA } from './constants'

export function cleanFormData() {
  return {
    type: COMMON_CLEAN_FORM_DATA,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_CLEAN_FORM_DATA:
      return {
        ...state,
        formData: {},
        saveFormDataPending: false,
        saveFormDataError: null,
        loadFormDataPending: false,
        loadFormDataError: null,
      }

    default:
      return state
  }
}
